import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = Object.freeze([
  {
    id: 'A/1',
    value: 'Abit.tipo signorile',
  },
  {
    id: 'A/2',
    value: 'Abit.tipo civile',
  },
  {
    id: 'A/3',
    value: 'Abit.tipo economico',
  },
  {
    id: 'A/4',
    value: 'Abit.tipo popolare',
  },
  {
    id: 'A/5',
    value: 'Abit.tipo ultrapopolare',
  },
  {
    id: 'A/6',
    value: 'Abit.tipo rurale',
  },
  {
    id: 'A/7',
    value: 'Abit.villini',
  },
  {
    id: 'A/9',
    value: 'Castelli, palazzi',
  },
  {
    id: 'A/10',
    value: 'Uffici e studi privati',
  },
  {
    id: 'A/11',
    value: 'Abitazioni tipici dei luoghi',
  },
  {
    id: 'C/1',
    value: 'Negozi e botteghe',
  },
  {
    id: 'C/2',
    value: 'Magazzini e locali deposito',
  },
  {
    id: 'C/3',
    value: 'Laboratori per arti,mestieri',
  },
  {
    id: 'C/4',
    value: 'Fabbr. per esercizi sportivi',
  },
  {
    id: 'C/5',
    value: 'Stabilimenti balneari e  cur.',
  },
  {
    id: 'C/6',
    value: 'Stalle, scuderie, rimesse, ecc',
  },
  {
    id: 'C/7',
    value: 'Tettoie chiuse od aperte',
  },
  {
    id: 'D/1',
    value: 'Opifici',
  },
  {
    id: 'D/2',
    value: 'Alberghi e pensioni',
  },
  {
    id: 'D/3',
    value: 'Teatri, cinema, sale concerti',
  },
  {
    id: 'D/4',
    value: 'Case di cura ed ospedali',
  },
  {
    id: 'D/5',
    value: 'Istituto di credito, assicur.',
  },
  {
    id: 'D/6',
    value: 'Fabbricati esercizi sportivi',
  },
  {
    id: 'D/7',
    value: 'Fabbricati per attiv.industr.',
  },
  {
    id: 'D/8',
    value: 'Fabbricati per attiv.commerc.',
  },
  {
    id: 'D/9',
    value: 'Edifici galleggianti o sosp.',
  },
  {
    id: 'D/10',
    value: 'Fabbricati per attiv. agric.',
  },
  {
    id: 'E/1',
    value: 'Stazioni per servizi di trasp',
  },
  {
    id: 'E/2',
    value: 'Ponti comunali e provinciali',
  },
  {
    id: 'E/3',
    value: 'Fabbricati per esig.pubbliche',
  },
  {
    id: 'E/4',
    value: 'Recinti c. per esig.pubbliche',
  },
  {
    id: 'E/5',
    value: 'Fabbricati fortificazioni',
  },
  {
    id: 'E/6',
    value: 'Fari, semafori, torri orologio',
  },
  {
    id: 'E/7',
    value: 'Fabbricati esercizio culto',
  },
  {
    id: 'E/8',
    value: 'Fabbricati nei cimiteri',
  },
  {
    id: 'E/8',
    value: 'Altri edifici',
  },
]);

interface ListCategoryProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListCategoryComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListCategoryProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="category-label">
        {required ? 'Cat. Catastale *' : 'Cat. Catastale'}
      </InputLabel>
      <PmiSelect
        labelId="category-label"
        id="category-Register"
        name="category-Register"
        value={value}
        label={required ? 'Cat. Catastale *' : 'Cat. Catastale'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list as Array<ItemVM>)?.map((category: ItemVM) => (
          <MenuItem key={category.id} value={category.id}>
            {category.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListCategoryComponent.displayName = 'List category component';

const ListCategory = memo(ListCategoryComponent);

export default ListCategory as typeof ListCategoryComponent;
